import React from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { LogIn } from "react-feather";
import { motion } from "framer-motion";
import pps from "../../src/images/logo512.png";

const Header = ({ setToggleLogin, latitude, longitude }) => {
  return (
    <motion.div
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Navbar expand="md" className="bg-white border-bottom shadow-sm py-3" sticky="top">
        <Container>
          {/* Brand Logo */}
          <Navbar.Brand href="/" className="d-flex align-items-center">
            <img src={pps} alt="Paupet Logo" style={{ width: "35px" }} className="me-2" />
            <span className="fw-bold" style={{ color: "#344e66", letterSpacing: "0.05em" }}>
              PAUPET SOFT
            </span>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-center">
              
              {/* ✅ Professional Dropdown using react-bootstrap */}
              <NavDropdown 
                title={<span className="fw-semibold text-secondary">BUSINESS</span>} 
                id="basic-nav-dropdown"
                className="me-3"
              >
                <NavDropdown.Item onClick={() => setToggleLogin(true)}>Medical</NavDropdown.Item>
                <NavDropdown.Item href="https://erp.paupetsoft.com/" target="_blank">ERP - Enterprise</NavDropdown.Item>
                <NavDropdown.Item href="https://college.paupetsoft.com/" target="_blank">ERP - College</NavDropdown.Item>
                <NavDropdown.Item href="https://library.paupetsoft.com/" target="_blank">Library</NavDropdown.Item>
                <NavDropdown.Item>Retail</NavDropdown.Item>
              </NavDropdown>

              {/* ✅ Login Action with Framer hover effect */}
              <motion.span
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => {
                  if (!latitude && !longitude) {
                    alert("Kindly share location before login for security");
                    return;
                  }
                  setToggleLogin(true);
                }}
                style={{ cursor: "pointer", color: "#344e66" }}
                className="d-flex align-items-center fw-bold"
              >
                <span className="me-2 d-none d-sm-inline" style={{ fontSize: "0.85rem" }}>LOGIN</span>
                <LogIn size={18} />
              </motion.span>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </motion.div>
  );
};

export default Header;